import { Injectable } from '@angular/core';
import { NotificationDTO } from '@app/@core/models/login-models';
import { Category, DocumentInterestDTO, PillDocumentsDTO } from '../model/training.model';
import { TrainingService } from './training.service';
import {
  COMUNICATIONS_PRINT_AC1,
  COMUNICATIONS_PRINT_AC2,
  COMUNICATIONS_PRINT_AA,
  COMUNICATIONS_PRINT_EA,
  COMUNICATIONS_TRANSPARENCY,
  COMUNICATIONS_MANUAL_GC_TRAD,
  URL_TUTORIAL_PROVIDER_ALLOWED_YOUTUBE,
  URL_TUTORIAL_PROVIDER_ALLOWED_VIMEO,
  URL_TUTORIAL_PROVIDER_ALLOWED_KALTURA,
  COMUNICATIONS_LIFEMANUAL,
  COMUNICATIONS_PAYMENTMANUAL,
} from '@core/constants/training.constants';

const PDFS_PRINTS_CONSUMPTION: DocumentInterestDTO[] = [
  {
    id: '',
    name: 'formationDocumentation.doc.selfemployed.consumption1',
    size: '0 KB',
    filename: COMUNICATIONS_PRINT_AC1,
    jasper: false,
    pdf: true,
  },
  {
    id: '',
    name: 'formationDocumentation.doc.comunity.consumption',
    size: '0 KB',
    filename: COMUNICATIONS_PRINT_AC2,
    jasper: false,
    pdf: true,
  },
];

const PDFS_PRINTS_AUTOS: DocumentInterestDTO[] = [
  {
    id: '',
    name: 'formationDocumentation.doc.selfemployed.autos',
    size: '0 KB',
    filename: COMUNICATIONS_PRINT_AA,
    jasper: false,
    pdf: true,
  },
  {
    id: '',
    name: 'formationDocumentation.doc.business.autos',
    size: '0 KB',
    filename: COMUNICATIONS_PRINT_EA,
    jasper: false,
    pdf: true,
  },
];

const PDFS_REQUEST_CREDIT: DocumentInterestDTO[] = [
  {
    id: '',
    name: 'formationDocumentation.doc.es.creditRequest',
    size: '0 KB',
    filename: '',
    jasper: true,
    pdf: false,
  },
  {
    id: '',
    name: 'formationDocumentation.doc.ca.creditRequest',
    size: '0 KB',
    filename: '',
    jasper: true,
    pdf: false,
  },
];

const PDFS_STATIC_COMUNICATIONS: DocumentInterestDTO[] = [
  {
    id: '',
    name: 'formationDocumentation.doc.financingGuide',
    size: '0 KB',
    filename: COMUNICATIONS_MANUAL_GC_TRAD,
    jasper: false,
    pdf: true,
  },
  {
    id: '',
    name: 'formationDocumentation.doc.transparency',
    size: '0 KB',
    filename: COMUNICATIONS_TRANSPARENCY,
    jasper: false,
    pdf: true,
  },
  {
    id: '',
    name: 'formationDocumentation.doc.paymentManual',
    size: '0 KB',
    filename: COMUNICATIONS_PAYMENTMANUAL,
    jasper: false,
    pdf: true,
  },
  {
    id: '',
    name: 'formationDocumentation.doc.lifeManual',
    size: '0 KB',
    filename: COMUNICATIONS_LIFEMANUAL,
    jasper: false,
    pdf: true,
  },
];

const TUTORIAL_PROVIDERS_ALLOWED: string[] = [
  URL_TUTORIAL_PROVIDER_ALLOWED_YOUTUBE,
  URL_TUTORIAL_PROVIDER_ALLOWED_VIMEO,
  URL_TUTORIAL_PROVIDER_ALLOWED_KALTURA,
];

@Injectable()
export class TrainingStore {
  private pdfsConsumption: DocumentInterestDTO[] = PDFS_PRINTS_CONSUMPTION;
  private pdfsAutos: DocumentInterestDTO[] = PDFS_PRINTS_AUTOS;
  private pdfsRequestCredit: DocumentInterestDTO[] = PDFS_REQUEST_CREDIT;
  private pdfsStaticComunications: DocumentInterestDTO[] = PDFS_STATIC_COMUNICATIONS;

  constructor(private trainingService: TrainingService) {}

  getTutorialProvidersAllowed = () => TUTORIAL_PROVIDERS_ALLOWED;

  getPdfsConsumption() {
    return this.pdfsConsumption;
  }

  getPdfsAutos() {
    return this.pdfsAutos;
  }

  getPdfsRequestCredit() {
    return this.pdfsRequestCredit;
  }

  getPdfsStaticComunications() {
    return this.pdfsStaticComunications;
  }

  getDocumentation(): Promise<NotificationDTO[]> {
    return new Promise<NotificationDTO[]>((resolve, reject) => {
      this.trainingService
        .loadReleasesMandatories()
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (error) => {
            console.log(error);
            reject(error);
          }
        );
    });
  }

  printJasper(id: string) {
    return new Promise<any>((resolve, reject) => {
      this.trainingService
        .postPrintJasperNotification(id)
        .toPromise()
        .then(
          (data) => (data ? resolve(data) : reject(data)),
          (error) => reject(error)
        );
    });
  }

  getPdfFromAssets(url: string) {
    return new Promise<any>((resolve, reject) => {
      this.trainingService
        .getPdf(url)
        .toPromise()
        .then(
          (data) => (data ? resolve(data) : reject(data)),
          (error) => reject(error)
        );
    });
  }

  getTutorials = (categoryId: string, lang: string) => {
    return new Promise<any>((resolve, reject) => {
      this.trainingService
        .getVideos(categoryId, lang)
        .toPromise()
        .then((data) => (data ? resolve(data) : reject(data)))
        .catch((error) => reject(error));
    });
  };

  getFeatured = (lang: string) => {
    return new Promise<any>((resolve, reject) => {
      this.trainingService
        .getTrainingFeatured(lang)
        .toPromise()
        .then((data) => (data ? resolve(data) : reject(data)))
        .catch((error) => reject(error));
    });
  };

  getCategories = (lang: string): Promise<Category[]> => {
    return new Promise<Category[]>((resolve, reject) => {
      this.trainingService
        .getCategories(lang)
        .toPromise()
        .then((data) => (data ? resolve(data) : reject(data)))
        .catch((error) => reject(error));
    });
  };

  getDocumentsPill = (lang: string): Promise<PillDocumentsDTO[]> => {
    return new Promise<PillDocumentsDTO[]>((resolve, reject) => {
      this.trainingService
        .getDocuments(lang)
        .toPromise()
        .then((data) => (data ? resolve(data) : reject(data)))
        .catch((error) => reject(error));
    });
  };
}
